import { TranslationKey } from '@/contexts/translations';
import { useTranslation } from '@/contexts/i18n-context';
import clsx from 'clsx';
import styles from './tab-set.module.css';
import { Button } from '../button';

interface TabIndexConfigBase {
  text: TranslationKey;
  isSelected: boolean;
}

interface TabIndexLinkConfig extends TabIndexConfigBase {
  to: string;
  onClick?: never;
}

interface TabIndexButtonConfig extends TabIndexConfigBase {
  to?: never;
  onClick: () => void;
}

export type TabIndexConfig = TabIndexLinkConfig | TabIndexButtonConfig;

interface TabSetProps {
  tabs: TabIndexConfig[];
  className?: string;
}

export function TabSet({ tabs, className }: TabSetProps) {
  const { t } = useTranslation();

  return (
    <div className={clsx(styles.tabSet, className)}>
      <div className={styles.tabButtons}>
        {tabs.map((tab) => (
          <Button
            key={tab.text}
            variant="textOnly"
            className={clsx(styles.tabButton, {
              [styles.tabButtonSelected]: tab.isSelected,
            })}
            {...(tab.to ? { as: 'a', to: tab.to } : { onClick: tab.onClick })}
          >
            {t(tab.text)}
          </Button>
        ))}
      </div>
    </div>
  );
}
